/**
 * @author Zdenka Valkučáková <zdenka.valkucakova@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/* eslint-env browser */

import { defineComponent } from 'vue';

// @ts-ignore Není to ESM.
import template from './status-info-dialog-advanced.html';

/**
 * @import { PropType } from 'vue'
 * @import { StatusInfoAdvanced } from '.'
 */

export default defineComponent({
  name: 'StatusInfoDialogAdvanced',
  template,
  emits: {},
  props: {
    info: {
      /** @type {PropType<StatusInfoAdvanced | undefined>} */
      type: Object,
      require: true
    }
  }
});
